import React, { Component } from "react";

export default class ImageAlt extends Component {
	
	constructor(props) {
		super(props)
		this.loadComplete = this.loadComplete.bind(this);
		this.handleResize = this.handleResize.bind(this);
		this.state = {
			loadImage: true,
			loaded: false,
			bracket:0,
		}
		
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		this.handleResize();
	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}
	
	handleResize() {
		
		let bracket = 0;
		
		if (this.$box) {

			let width = this.$box.clientWidth * window.devicePixelRatio;
			if (width < 480) {
				bracket = 0;
			} else if (width < 640) {
				bracket = 1;
			} else if (width < 1024) {
				bracket = 2;
			} else if (width < 1280) {
				bracket = 3;
			} else if (width < 1440) {
				bracket = 4;
			} else if (width < 1920) {
				bracket = 5;
			} else {
				bracket = 6;
			}
		
		}
		
	    if (this.bracket !== bracket) {
		    this.setState({
			    bracket: bracket
			});
			
	    }
	}
	
	loadComplete() {
		if (this.$imageEl.complete) {
			this.setState({loaded:true});
		}
	}
	
	render() {
		
		let srcset = this.props.srcset;
		let src = this.props.src;
		let width = this.props.width;
		let height = this.props.height;
				
		let rvSrc = src;
		try {
			rvSrc = srcset.split(', ')[this.state.bracket].split(' ')[0];
		} catch (error) {
			rvSrc = src;
		}
		
		if (srcset) {
			
			if (width && height) {

				return (
					<div className={'c-media c-media--block ' + (this.state.loaded ? "state-media-loaded" : "")} ref={(box) => { this.$box = box; }} style={{paddingTop:((height/width) * 100) + '%'}}>
						<div className="c-media__inner">
							{this.state.loadImage &&
								<img
									ref={(imageEl) => { this.$imageEl = imageEl; }}
									onLoad={this.loadComplete}
									alt=""
									src={rvSrc.replaceAll('jpg','jpg')}
								/>
							}
						</div>
					</div>
				)
			
			} else {
				
				return (
					<div className={'c-media ' + (this.state.loaded ? "state-media-loaded" : "")} ref={(box) => { this.$box = box; }}>
						<div className="c-media__inner">
							{this.state.loadImage &&
								<img
									ref={(imageEl) => { this.$imageEl = imageEl; }}
									onLoad={this.loadComplete}
									alt=""
									src={rvSrc.replaceAll('jpg','jpg')}
								/>
							}
						</div>
					</div>
				)
				
			}
							
    	} else {
			return null
    	}
	}
}
